export default {
    red: "#fc5c65",
    orange: "#fc5c65",
    yellow: "#fed330",
    green: "#26de81",
    teal: "#2bcbba",
    lightblue: "#45aaf2",
    blue: "#4b7bec",
    purple: "#a55eea",
    defaulttimeline: "#fc5c65",
    defaultcampaign: "#4b7bec",
    lightgray: "#cccccc"
}